import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from '@reduxjs/toolkit';
import {
  encryptedStorage,
  EncryptedStorageKeys,
} from '@setup/encryptedStorage/encryptedStorage';
import { userSlice } from '../userSlice';

export const localStorageMiddleware: Middleware =
  (_api: MiddlewareAPI) => (next) => (action) => {
    if (userSlice.endpoints.signUp.matchFulfilled(action)) {
      encryptedStorage.setItem(
        EncryptedStorageKeys.AccessToken,
        action.payload.accessToken
      );
    } else if (
      userSlice.endpoints.logout.matchFulfilled(action) ||
      userSlice.endpoints.accessToken.matchFulfilled(action) ||
      userSlice.endpoints.updatePassword.matchFulfilled(action) ||
      (isRejectedWithValue(action) && action.payload.status === 401)
    ) {
      encryptedStorage.removeItem(EncryptedStorageKeys.AccessToken);
    }
    return next(action);
  };
